<template>
  <div
    class="mt-32 mt-sm-0 mx-sm-n16 p-24 p-sm-16 border-radius-lg border-stroke-outermost"
  >
    <div class="fs-20 fw-medium">Специальные возможности</div>
    <div class="pt-12">
      <button
        v-if="isVideoCallAvailable"
        class="btn color-dark w-100 mt-20"
        @click="openVideoCall()"
      >
        <span class="d-block icon-20">
          <svg>
            <use
              xlink:href="/local/components/orteka/catalog.element/src/assets/img/sprite.svg#icon-camera-security"
            ></use>
          </svg>
        </span>
        <span class="grid-col_full text-left px-8 d-block">
          Видеоконсультация
        </span>
        <span class="d-block icon-12">
          <svg>
            <use
              xlink:href="/local/components/orteka/catalog.element/src/assets/img/sprite.svg#icon-chevron-right"
            ></use>
          </svg>
        </span>
      </button>

      <button
        v-for="(item, index) in getSpecial"
        :key="index"
        class="btn color-dark w-100 mt-20"
      >
        <span class="d-block icon-20">
          <img v-if="item.icon.length" :src="item.icon" alt="Иконка" />
        </span>

        <PopupSpecial
          :name="item.name"
          :link="item.link"
          :text="item.detail_text"
        />

        <span class="d-block icon-12">
          <svg>
            <use
              xlink:href="/local/components/orteka/catalog.element/src/assets/img/sprite.svg#icon-chevron-right"
            ></use>
          </svg>
        </span>
      </button>

      <button class="btn color-dark w-100 mt-20">
        <span class="d-block icon-20">
          <svg>
            <use
              xlink:href="/local/components/orteka/catalog.element/src/assets/img/sprite.svg#icon-car-alt"
            ></use>
          </svg>
        </span>
        <a
          href="#doctorRecord"
          class="grid-col_full text-left px-8 d-block js-popup-inline"
        >
          Записаться к ортопеду
        </a>
        <span class="d-block icon-12">
          <svg>
            <use
              xlink:href="/local/components/orteka/catalog.element/src/assets/img/sprite.svg#icon-chevron-right"
            ></use>
          </svg>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapState } from "pinia";
import PopupSpecial from "@/pages/product_card/components/Popups/PopupSpecial.vue";

export default {
  name: "ProductVideoCall",
  components: { PopupSpecial },
  computed: {
    ...mapState(useProductStore, ["isVideoCallAvailable", "getSpecial"]),
  },
  methods: {
    openVideoCall() {
      window.openCallPopup();
    },
  },
};
</script>
